var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center mt-sm-5"},[_vm._v("\n\tPlease select a song from the list or "),_c('router-link',{attrs:{"to":"/songs/add"}},[_vm._v("add a new one")]),_vm._v(".\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }